import { apiRegistry } from '../../../common/infra/apiRegistry'
import { storageMem } from '../mem/filesMem'

apiRegistry.registerGetApi('getStorageInfo', async () => {
  return storageMem
})